import { LuArrowRight } from 'react-icons/lu'

import ServicesCard from '#/components/common/ServicesCard'

import servicesBackground from '#/assets/services/services-bg.webp'
import servicesBackgroundMobile from '#/assets/services/services-bg-mobile.webp'
import servicesDecor from '#/assets/services/services-decor.svg'
import headerIcon from '#/assets/header-icon.svg'
import { RevealItem, ScrollReveal } from '#/components/common/ScrollReveal'
import { TextAnimate } from '#/components/common/TextAnimate'
import { SERVICES, SERVICES_CONTENT } from '#/data/homeServices'

export default function ServicesSection() {
  return (
    <section className="relative w-full py-15 overflow-hidden" id="services">
      <div className="absolute inset-0">
        <picture aria-hidden="true" className="block size-full">
          <source
            media="(max-width: 768px)"
            srcSet={servicesBackgroundMobile}
            width={768}
            height={1376}
          />
          <img
            alt=""
            className="size-full object-cover"
            src={servicesBackground}
            loading="lazy"
            decoding="async"
            width={1280}
            height={800}
          />
        </picture>
        <div className="absolute inset-0 bg-secondary-600/85" />
      </div>

      <img
        alt=""
        className="pointer-events-none absolute right-0 top-0"
        src={servicesDecor}
        loading="lazy"
        decoding="async"
        width={300}
        height={300}
      />
      <div className="container relative mx-auto flex flex-col items-center gap-[50px] ">
        <ScrollReveal className="flex w-full max-w-188 flex-col items-center justify-center gap-[12px] text-center">
          <RevealItem>
            <img alt="" src={headerIcon} />
          </RevealItem>
          <RevealItem>
            <p className="text-[20px] font-heading font-bold leading-[normal] text-white ">
              {SERVICES_CONTENT.eyebrow}
            </p>
          </RevealItem>
          <RevealItem className="w-full">
            <TextAnimate
              by="word"
              animation="blurInUp"
              as="h2"
              className="text-[60px] font-bold leading-[normal] text-white max-md:text-[44px] max-sm:text-[34px]"
            >
              {SERVICES_CONTENT.title}
            </TextAnimate>
          </RevealItem>
        </ScrollReveal>

        <ScrollReveal
          className="grid w-full grid-cols-1 gap-7.5 md:grid-cols-2 xl:grid-cols-3"
          stagger={0.12}
        >
          {SERVICES.map((service) => (
            <RevealItem className="h-full" key={service.title}>
              <ServicesCard
                variant="service"
                icon={<service.icon />}
                title={service.title}
                description={service.description}
                index={service.index}
                actionLabel={SERVICES_CONTENT.actionLabel}
                actionIcon={<LuArrowRight />}
              />
            </RevealItem>
          ))}
        </ScrollReveal>
      </div>
    </section>
  )
}
